// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { rfqJobQuoteDetailsProductCardStyles } from "@conklin/Overrides/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductCard";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { css } from "styled-components";

const qtyField: SmallHeadingAndTextStyles = {
    heading: {
        size: 12,
        weight: "normal",
        css: css`
            line-height: 15px;
            text-transform: capitalize;
            padding: 0;
            margin-bottom: 4px;

            @media print {
                &&& {
                    font-size: 14px;
                    line-height: 16px;
                }
            }
        `,
    },
    text: {
        size: 16,
        weight: "bold",
        lineHeight: "19px",
    },
};

rfqJobQuoteDetailsProductCardStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

rfqJobQuoteDetailsProductCardStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqJobQuoteDetailsProductCardStyles.productPartNumbers = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                flex-grow: unset;
            `,
        },
    }),
};

rfqJobQuoteDetailsProductCardStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

rfqJobQuoteDetailsProductCardStyles.qtySectionWrapper = {
    css: css`
        margin-bottom: 10px;
    `,
};

rfqJobQuoteDetailsProductCardStyles.jobQuantityHeadingAndText = {
    ...qtyField,
};

rfqJobQuoteDetailsProductCardStyles.purchasedQuantityHeadingAndText = {
    ...qtyField,
};

rfqJobQuoteDetailsProductCardStyles.quantityRemainingHeadingAndText = {
    ...qtyField,
};

rfqJobQuoteDetailsProductCardStyles.orderQtyErrorStyle = {
    size: 12,
    weight: "normal",
    color: "danger",
    transform: "capitalize",
    css: css`
        margin-top: 8px;
    `,
};

rfqJobQuoteDetailsProductCardStyles.cartLineNotesStyles = {
    ...cartLineSharedStyles.cartLineNotes,
};

rfqJobQuoteDetailsProductCardStyles.qtyOrderedField = {
    qtyLabel: {
        css: css`
            display: none;

            ${xScreen("lte", "md")} {
                display: block;
            }
        `,
    },
};

rfqJobQuoteDetailsProductCardStyles.toggleNotesLink = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
        css: css`
            display: flex;
            gap: 8px;
            align-items: center;
        `,
    },
};

rfqJobQuoteDetailsProductCardStyles.cartLineContainer = {
    total: {
        css: css`
            display: flex;
            justify-content: end;
            align-items: flex-start;
        `,
    },
    qty: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 3;
            }
        `,
    },
};
